import { UI_TAGS } from "@/presentation/helpers/uiTags.js";

export function createMenuBtn(k, x, y, textString, textSize, onClickCallback) {
    const btn = k.add([
        k.sprite("SmallRedSquareButton_Regular"),
        k.pos(x, y),
        k.anchor("center"),
        k.area(),
        k.z(6),
        k.scale(0.8),
        UI_TAGS.MENU_BUTTON
    ]);

    const txt = btn.add([
        k.text(textString, { size: textSize, font: "lilita" }),
        k.pos(0, 0),
        k.anchor("center"),
        k.z(7),
    ]);

    btn.onClick(() => {
        btn.use(k.sprite("SmallRedSquareButton_Pressed"));
        txt.pos = k.vec2(0, 10);
        k.play("sheep", { volume: 0.3, speed: 1, loop: false });

        // délai pour animation
        k.wait(0.2, () => {
            onClickCallback();

            // revenir au bouton normal
            btn.use(k.sprite("SmallRedSquareButton_Regular"));
            txt.pos = k.vec2(0, 0);
        });
    });

    return btn;
}